import { useParams } from "react-router-dom";

import PageHeader from "pages/components/PageHeader";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Card from "@mui/material/Card";

export default function InventarioDetalhe() {
  const { idinventario } = useParams();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageHeader />

      <MDBox mt={2}>
        <Card>
          <MDBox p={2}>
            <MDTypography variant="h6">Detalhe do inventário</MDTypography>

            <MDTypography variant="caption" color="text">
              ID do inventário: {idinventario}
            </MDTypography>
          </MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
